import { Collapse } from '@pets-ui/Collapse/Collapse'
import * as stylex from '@stylexjs/stylex'
import { useState } from 'react'
import style from '../style/components/child-faq.module.scss'
import { Expand } from './icon'

const styles = stylex.create({
  answerWrapper: {
    fontSize: '0.75rem',
    whiteSpace: 'pre-line',
    marginTop: '0.5rem',
  },
})

interface ChildFAQProps {
  mainData: FAQ.MainQA
}

interface FAQCollapseProps {
  data: FAQ.QA
}

const ChildClientFAQ = ({ mainData }: ChildFAQProps) => {
  return (
    <main className={style.main}>
      <div className={style.title}>{mainData.title}</div>
      <hr className={style.line} />
      {mainData.data.map(item => (
        <FAQCollapse key={item.question} data={item} />
      ))}
    </main>
  )
}

const FAQCollapse = ({ data }: FAQCollapseProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const onToggle = () => {
    setIsOpen(!isOpen)
  }
  return (
    <div>
      <button className={style['button-wrapper']} onClick={onToggle}>
        <span className={style.question}>{data.question}</span>
        <Expand className={`${style.icon} ${isOpen ? style['icon-active'] : ''}`} />
      </button>
      <Collapse rootStyle={styles.answerWrapper} in={isOpen}>
        {data.answer}
      </Collapse>
    </div>
  )
}

export default ChildClientFAQ
